import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import download from '../../../Images/download.svg';
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { getCustomSettings, getcommonPortfolios, getcommonAssets, getcategory,getUserPageAccess, getClientWebSites,insertorupdatewebsite,deletewebsite} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { SBADropDown, SBAComboBox } from "../../UiComponents/SBADropDown";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { AgGridReact } from 'ag-grid-react';
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { exportToExcelUsingRef } from '../../utils/excelExporter';
export const ClientWebsite = () => {
    const Level = [{ BreadCrumb: "Admin > Client Websites", Routes: "/Admin" }];
    const [colDef, setColDef] = useState();
    const [appliedFilter, setAppliedFilter] = useState(null);
    const clientwebsiteGridRef = useRef();

    const [lstClientwebsiteloginId,setlstClientwebsiteloginId]=useState("");
    const [lstwebsiteName,setlstwebsiteName]=useState("");
    const [lstwebAddress,setlstWebAddress]=useState("");
    const [lstportfolio,setlstportfolio]=useState(null);
    

    const [showDrawer, setshowDrawer] = useState(false);
    const [portfolio, setPortfolio] = useState();
    const [Asset, setAsset] = useState();
    const [activityType, setactivityType] = useState();
    const [type, setType] = useState([
        {TypeId: -1, TypeName: "--Select--"},
        { TypeId: 1, TypeName: "Client" },
        { TypeId: 2, TypeName: "Accounting" },
    ]);
    const [lsttypeId,setlstTypeId]=useState(type[0]);
    const [clientWebsiteList, setClientWebSiteList] = useState([]);
    const [clientWebsitedata, setClientWebSitedata] = useState([]);

    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedType, setSelectedType] = useState(null);


    const [rowPortfolio, setRowPortfolio] = useState();
    const [rowAsset, setRowAsset] = useState([]);
    const [rowType, setRowType] = useState([]);
    const [rowSecretQuestAns,setRowSecretQuestAns] = useState([]);

    const [webSiteName,setWebSiteName]=useState(null);
    const [url,setURL]=useState();
    const [userName,setUserName]=useState();
    const [password,setPassword]=useState();
    const [dType,setDType]=useState(type[0]);
    const [question,setQuestion]=useState();
    const [answer,setAnswer]=useState();
    const [notes,setNotes]=useState();
    const [showpassword,setShowPassword]=useState(false);
    const [showpasswordModal,setshowpasswordModal]=useState(false);
    const [passwordText,setPasswordText]=useState();
    const [showpasswordtxt,setShowPasswordtxt]=useState(false);
    const [showdeleteModal,setShowDeleteModal]=useState(false);
    const[clientWebsiteloginId,setclientWebsiteloginId]=useState(0);
    const[clientwebsiteAccess,setclientwebsiteAccess]=useState(false);
    const[clientwebsiteEditAccess,setclientwebsiteEditAccess]=useState(false);
    const getFormattedDate=(value)=>{
        return value ? moment(value).format("MM-DD-YYYY") : "";
      };
    const getClientWebSiteDatas = async () => {
        try {
            const cws = await sbaAxios({ url: `${getClientWebSites}`,
            method: 'get',});
            setClientWebSiteList(
                cws.map((item,index)=>({...item,ModifiedDate:getFormattedDate(item.ModifiedDate)}))
              );
            
        } catch (error) {
            setClientWebSiteList([]);
        }
    };
    useEffect(() => {
        getClientWebSiteDatas();
        getClientWebsiteAccess();
    }, [])

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            const columns = customSettings?.columns.filter(item => item.colId !== "Action").map(item => ({ ...item }));
            setColDef(columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    useEffect(() => {

        document.title = `Client Websites`;
        fetchGridData();
        getCustomSetting();
        getportfolio('null');
        getAssets('null');
        getdocumentType();
    }, []);
    const eyeRenderer=(props)=>
    {
        const handleclick = () => {
            setshowpasswordModal(true);
            if(props.data.WebPassword==="The input is not a valid Base-64 string as it contains a non-base 64 character, more than two padding characters, or an illegal character among the padding characters.")
          {
            setPasswordText();
          }
          else
          { 
             setPasswordText(props.data.WebPassword);
          }
        };
             return (
               
            <div className="actions-cell">
        <i className="fa-solid fa-eye" onClick={handleclick}></i>
        </div>
       
             )
        
    }
    const searchClientWebSiteDatas = async () => {
        
        try {
            const cws = await sbaAxios({ url: `${getClientWebSites}?webName=${lstwebsiteName}&webAddress=${lstwebAddress}&WebsiteLoginId=${lstClientwebsiteloginId}&websiteLoginTypeId=${lsttypeId.TypeId===-1?null:lsttypeId.TypeId||null}&portfolioId=${lstportfolio?.PortfolioId||null}`,
            method: 'get',});
            setClientWebSiteList(
                cws.map((item,index)=>({...item,ModifiedDate:getFormattedDate(item.ModifiedDate)}))
              );
        } catch (error) {
            console.log(error,"getdatas")
            setClientWebSiteList([]);
        }
    };
    const ActionsRenderer =  (props) => {
        const handleEditClick = async() => {
            getClientWebsiteAccess();
            setshowDrawer(true);
            setAnswer("");
        setQuestion("");
        setSelectedAsset();
        setSelectedPortfolio();
        setSelectedType();
            try {
                const cws = await  sbaAxios({ url: `${getClientWebSites}?WebsiteLoginId=${props.data.WebsiteLoginId}`,
                method: 'get',});
                setClientWebSitedata(cws);
                setWebSiteName(cws[0].WebsiteName);
                setURL(cws[0].WebAddress)
                setUserName(cws[0].WebUsername);
                if(cws[0].WebPassword==="The input is not a valid Base-64 string as it contains a non-base 64 character, more than two padding characters, or an illegal character among the padding characters.")
                {
                    setPassword();
                }
                else{
                setPassword(cws[0].WebPassword)
                }
                setNotes(cws[0].Notes)
                setclientWebsiteloginId(props.data.WebsiteLoginId)
                setDType({TypeId:cws[0].WebsiteLoginTypeId,TypeName:cws[0].WebsiteLoginTypeName})
                const portfoliodt=cws[0].MappingList.filter(item => item.MappingTypeId === 1);
                setRowPortfolio(portfoliodt.map((item) => ({ 
                   
                    PortfolioId: item.Id, 
                    Name: item.Name
                })));
                const assetdt=cws[0].MappingList.filter(item => item.MappingTypeId === 2);
                setRowAsset(assetdt.map((item) => ({ 
                   
                    AssetId: item.Id, 
                    AssetName: item.Name
                })));
                const doctypedt=cws[0].MappingList.filter(item => item.MappingTypeId === 3);
                setRowType(doctypedt.map((item) => ({ 
                   
                    ActivitySubTypeId: item.Id, 
                    ActivitySubType: item.Name
                })));
            } catch (error) {
                setWebSiteName();
                setURL()
                setUserName();
                setPassword();
                setNotes()
                setclientWebsiteloginId();
                setDType()
                setRowPortfolio([]);
                setRowAsset([]);
                setRowType([]);
                setRowSecretQuestAns([])
            }
       
        };
        const handleDeleteClick = () => {
            setShowDeleteModal(true);
            setclientWebsiteloginId(props.data.WebsiteLoginId);
        }
        return (
            <div className="actions-cell">
                <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={handleEditClick}></i>

                <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick} ></i>
            </div>)

    };
    const dateformat = (params) => {
        if (!params.value) {
            return "";
        }
        return moment(params.value).format("MM/DD/YYYY");
    }
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1027}` });
            if (response) {

                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => {
                  
                      
                   


                     if (item.colId === "ModifiedDate") {
                        return { ...item, "field": item.colId, cellRenderer: dateformat, filter: false, "headerName": "Modified Date"}
                    }
else if(item.colId === "WebPassWord")
{
    return { ...item, cellRenderer: eyeRenderer, "field": item.colId, filter: false } 
}

                    else
                        return { ...item, cellRenderer: null, "field": item.colId, filter: 'agTextColumnFilter' }
                });
               
                    formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: ActionsRenderer, filter: false });
             
               
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const getportfolio = async (search) => {
        try {
            const list = await sbaAxios({
                url: getcommonPortfolios,
                params: {
                    searchTerm: search,
                }
            });
            setPortfolio(list);
            return list
        } catch (error) {
            return [];
        }
    }
    const getAssets = async (search) => {
        try {
            const list = await sbaAxios({
                url: getcommonAssets,
                params: {
                    searchTerm: search,
                }
            });
            setAsset(list);
            return list
        } catch (error) {
            return [];
        }
    }
    const getdocumentType = async () => {
        try {
            const list = await sbaAxios({
                url: `${getcategory}${2}`,
            });
            setactivityType(list);
            return list
        } catch (error) {
            return [];
        }
    }


    const openAddDrawer = () => {
        setRowAsset([]);
        setRowPortfolio([]);
        setRowType([]);
        setshowDrawer(true);
        setWebSiteName();
        setURL()
        setUserName();
        setPassword();
        setNotes()
        setclientWebsiteloginId();
        setDType(type[0]);
        setAnswer("");
        setQuestion("");
        setSelectedAsset();
        setSelectedPortfolio();
        setSelectedType();
        setRowPortfolio([]);
        setRowAsset([]);
        setRowType([]);
        setRowSecretQuestAns([]);
    }
        
    const DeleteRenderer = (props,type) => {
      
        const handleDeleteClick = () => {
            if(type=="Portfolio")
            setRowPortfolio(val=>val.filter(item=>item.PortfolioId!=props.data.PortfolioId));
            if(type=="Asset")
            setRowAsset(val=>val.filter(item=>item.AssetId!=props.data.AssetId));
            if(type=="Document")
            setRowType(val=>val.filter(item=>item.ActivitySubTypeId!=props.data.ActivitySubTypeId));
            if(type=="Secrete")
            setRowSecretQuestAns(val=>val.filter(item=>item.Question!=props.data.Question));
        }
        return (
            <div className="actions-cell">
                <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={()=>{handleDeleteClick()}}></i>
            </div>)

    };
    const portfolioColumnDefs = [
        { headerName: 'Portfolio Name', field: 'Name', resizable: true },
        {
            headerName: '',
            field: '',
            cellRenderer: (e)=>{return DeleteRenderer(e,'Portfolio')},
            sortable: false,
            filter: false,
            maxWidth: 100 
        }
    ];
    const AssetColumnDefs = [
        { headerName: 'Asset Name', field: 'AssetName', resizable: true },
        {
            headerName: '',
            field: '',
            cellRenderer: (e)=>{return DeleteRenderer(e,'Asset')},
            sortable: false,
            filter: false,
            maxWidth: 100
        }
    ];
    const DocumentColumnDefs = [
        { headerName: 'Document Type', field: 'ActivitySubType', resizable: true },
        {
            headerName: '',
            field: 'Delete',
            cellRenderer: (e)=>{return DeleteRenderer(e,'Document')},
            sortable: false,
            filter: false,
            maxWidth: 100
        }
    ];
    const secretcolDef = [
        { headerName: 'Secret Question', field: 'Question', minWidth: 250, resizable: true },
        { headerName: 'Secret Answer', field: 'Answer', minWidth: 250, resizable: true },
        {
            headerName: '',
            field: 'Delete',
            cellRenderer: (e)=>{return DeleteRenderer(e,'Secrete')},
            sortable: false,
            filter: false,
            maxWidth: 100
        }
    ];
    const addPortfolio=()=>{
       
        if(selectedPortfolio)
        {
            if(selectedPortfolio.PortfolioId==undefined || selectedPortfolio.PortfolioId==0 || selectedPortfolio.PortfolioId==null)
            {
                SBNotify({ Msg: "Please Select the Portfolio", type: "error"}); 
            }
            else
            {
            if(!rowPortfolio?.find(item=>item.PortfolioId==selectedPortfolio.PortfolioId))
            {
            setRowPortfolio(val=>[...val,selectedPortfolio])
            }

              else
              {
            SBNotify({ Msg: "Portfolio already exist", type: "error"});
              }
            }
        }
       
        setSelectedPortfolio([]);
    };
    const addAsset=()=>{
        
        if(selectedAsset)
        {
            if(selectedAsset.AssetId==undefined || selectedAsset.AssetId==0 || selectedAsset.AssetId==null)
            {
                SBNotify({ Msg: "Please Select the Asset", type: "error"});  
            }
            else

            {
            if(!rowAsset?.find(item=>item.AssetId==selectedAsset.AssetId))
            setRowAsset(val=>[...val,selectedAsset])
            else
            SBNotify({ Msg: "Asset already exist", type: "error"});
            }
        }
        
        setSelectedAsset([]);
    }
    const addType=()=>{
       
        if(selectedType)
        {
             if(selectedType.ActivitySubTypeId==undefined || selectedType.ActivitySubTypeId==0 || selectedType.ActivitySubTypeId==null)
            {
                SBNotify({ Msg: "Please Select the Document Type", type: "error"});  
            }
            else

            {
            if(!rowType?.find(item=>item.ActivitySubTypeId==selectedType.ActivitySubTypeId))
            setRowType(val=>[...val,selectedType])
            else
            SBNotify({ Msg: "Document Type already exist", type: "error"});
        }
    }
       
        setSelectedType([]);
    }
const addSecretQuestions=()=>
{
   
    if(question==undefined|| question ==null || question==0)
    {
        SBNotify({ Msg: "Please Enter Question", type: "error"}); 
        return;
    }
    if(answer==undefined|| answer ==null || answer==0)
    {
        SBNotify({ Msg: "Please Enter Answer", type: "error"}); 
        return;
    }
     else
    {
        const secretquestionanswer={id:0,Question:question,Answer:answer}
        if(!rowSecretQuestAns?.find(item=>item.Question==question))
        setRowSecretQuestAns(val=>[...val,secretquestionanswer]);
        else
        SBNotify({ Msg: "Question already exist", type: "error"});
    }
    setQuestion("");
    setAnswer("");

}

    const insertorupdateclientwebsite=()=>
    {
        let ifsave=true;
        if (!webSiteName) {
            SBNotify({ Msg: "Please Enter Website Name", type: "error"});
            ifsave = false;

            return;
        }
         if (!url) {
            SBNotify({ Msg: "Please Enter URL", type: "error"});
            ifsave = false;

            return;
        }
        if (!userName) {
            SBNotify({ Msg: "Please Enter User Name", type: "error"});
            ifsave = false;

            return;
        }
        if (!password) {
            SBNotify({ Msg: "Please Enter Password", type: "error"});
            ifsave = false;

            return;
        }
        if (dType.TypeId=="-1") {
            SBNotify({ Msg: "Please Select Type", type: "error"});
            ifsave = false;

            return;
        }
        const data={
            
            WebsiteLoginId: clientWebsiteloginId,
            WebsiteName: webSiteName, 
           WebAddress: url, 
            WebUsername: userName,
           WebPassword: password,
            Notes: notes,
           WebsiteLoginTypeId: dType.TypeId,
            MappingList:[
                ...rowPortfolio.map((item) => ({ 
                    MappingTypeId: 1,
                    Id: item.PortfolioId, 
                    Name: item.Name
                })),
                ...rowAsset.map((item) => ({ 
                    MappingTypeId: 2,
                    Id: item.AssetId,
                    Name: item.AssetName
                })),
                ...rowType.map((item) => ({ 
                    MappingTypeId: 3,
                    Id: item.ActivitySubTypeId,
                    Name: item.ActivitySubType
                })),
                ...rowSecretQuestAns.map((item)=>
                ({
                    MappingTypeId: 4,
                    Id: 0,
                    Question: item.Question,
                    Answer: item.Answer 
                }))
            ]
        }

        if (ifsave) {
            sbaAxios({
                url: `${insertorupdatewebsite}`,
                method: "post",
                data: data,
            }).then((response) => {
                getClientWebSiteDatas();
              setshowDrawer(false);
                SBNotify({ Msg: "Website Saved Successfully", type: "success" });
                
               
            }).catch((error) => {
              SBNotify({ Msg: "some error  occured", type: "error" });
            });
    }
}
const togglePasswordTextVisibility = () => {
    setShowPassword(!showpassword);
  };
    const togglePasswordTxtVisibility=()=>
    {
        setShowPasswordtxt(!showpasswordtxt);
    }
    const deleteClientWebsite=()=>
    {
        sbaAxios({
            url: `${deletewebsite}/${clientWebsiteloginId}`,
            method: "get",
        }).then((response) => {
            getClientWebSiteDatas();
          setShowDeleteModal(false);
            SBNotify({ Msg: "Website Deleted Successfully", type: "success" });
            
           
        }).catch((error) => {
            SBNotify({ Msg: "some error  occured", type: "error" });
            setShowDeleteModal(false);
        });
    }
    const copyToClipboardpassword = () => {
        const textToCopy = `${password}`;
        navigator.clipboard.writeText(textToCopy)      
      };
      const copyToClipboardpasswordtxt = () => {
        const textToCopy = `${passwordText}`;
        navigator.clipboard.writeText(textToCopy)      
      };

      const getClientWebsiteAccess = async  () => {
        try {
          const clientwebsiteAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientWebsitesAccess` });
          const clientwebsiteEditAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientWebsiteClientEditAccess` });
          const [
           
            clientwebsiteAccessResponse,
            clientwebsiteEditAccessResponse,
           
          ] = await Promise.all([
            
            clientwebsiteAccessPromise,
            clientwebsiteEditAccessPromise
          ]);
         
          setclientwebsiteAccess(clientwebsiteAccessResponse);
          setclientwebsiteEditAccess(clientwebsiteEditAccessResponse);
        } catch (error) {
          console.error("An error occurred:", error);
          
        }
      };
return (
        <>
        {clientwebsiteAccess ?
        <div>
          <TopBar label={"Client Websites"} />
           <div className="mainContentData">
           <BreadCrumbs Levels={Level} />
               
                <div className="container-fluid">
                    <div className="row ">
                        <div className="col-md-2 ">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Website Login Id
                            </label>
                            <div>
                                <input
                                    className="w-75 input-default form-control"
                                    type="text"
                                    
                                    onChange={(e)=>{setlstClientwebsiteloginId(e.target.value)}}
                                />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12 d-block"
                            >
                                Website Name
                            </label>
                            <input
                                className="w-75 input-default form-control"
                                type="text"
                                onChange={(e)=>{setlstwebsiteName(e.target.value)}}
                            />
                        </div>
                        <div className="col-md-2">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Website Address
                            </label>
                            <div>
                                <input
                                    className="w-75 input-default form-control"
                                    type="text"
                                    onChange={(e)=>{setlstWebAddress(e.target.value)}}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Portfolios
                            </label>
                            <div>
                                <SBAComboBox
                                    className="w-100"
                                    textField={"Name"}
                                    valueField={"PortfolioId"}
                                    data={portfolio}
                                    value={lstportfolio}
                                    onChange={(e)=>{setlstportfolio(e.value)}}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Type
                            </label>
                            <div>
                                <SBADropDown
                                    className="w-50"
                                    textField={"TypeName"}
                                    valueField={"TypeId"}
                                    data={type}
                                    value={lsttypeId}
                                    onChange={(e)=>{setlstTypeId(e.value)}}
                                ></SBADropDown>
                            </div>
                        </div>
                        <div className=" col-md-2 mt-4 d-flex justify-content-end gap-2">
                        <button type="submit" className="p-sm-btn mx-1" onClick={searchClientWebSiteDatas}> Search</button>
                            <button type="submit" className="p-sm-btn mx-1" onClick={openAddDrawer} ><i className="fa-solid fa-plus" /> Add</button>
                            <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(clientwebsiteGridRef, "Client WebSites.xlsx") }}><img src={download} alt="Excel" />Export</button>
                        </div>
                    </div>
                    <div className="ag-theme-alpine" style={{ width: '100%', height: '70vh' }}>
                    <SBGrid  ref={clientwebsiteGridRef}   rowData={clientWebsiteList} column={colDef}  filters={appliedFilter} componentID={1027} gridStyle={{ width: '100%', height: '70vh' }}></SBGrid>
            
                    </div>
                </div>
            </div>
            </div>
            :<div>
                  <TopBar label={"Client Websites"} />
                  <div className="mainContentData">
                    <BreadCrumbs Levels={Level} />
                    <div className="container-fluid">
                Unauthorized Access
                </div>
                </div>
                </div>
                }
            <SBADrawer
                open={showDrawer}
                setOpen={setshowDrawer}
                close={false}
                title={"Save Client Websites"}
                style={{ width: "80vw" }}
            >
                <div className="row">
                    <div className="col-md-3">
                   <div className="my-1">
                   <label
                            className="me-2 fw-semibold fs-12"
                        >
                            Website Name
                            <span className="mandatory">*</span>
                        </label>

                        <input
                            className="input-default form-control"
                            type="text"
                            value={webSiteName}
                            onChange={(e)=>{setWebSiteName(e.target.value)}}
                        />
                   </div>
                   <div className="my-1">
                   <label
                            className="me-2 fw-semibold fs-12"
                        >
                            URL
                            <span className="mandatory">*</span>
                        </label>
                        <input
                            className="input-default form-control"
                            type="text"
                            value={url}
                            onChange={(e)=>{setURL(e.target.value)}}
                        />
                   </div>
                   <div className="my-1">
                   <label
                            className="me-2 fw-semibold fs-12"
                        >
                            User Name
                            <span className="mandatory">*</span>
                        </label>
                        <input
                            className="input-default form-control"
                            type="text"
                            value={userName}
                            onChange={(e)=>{setUserName(e.target.value)}}
                        />
                   </div>
                   <div className="my-1">
                   <label
                            className="me-2 fw-semibold fs-12"
                        >
                            Password
                            <span className="mandatory">*</span>
                        </label>
                        <div className="d-flex">
                        <input
                            className="input-default form-control"
                            type={
                                showpassword ? "text" : "password"
                              }
                            value={password}
                            onChange={(e)=>{setPassword(e.target.value)}}
                        />
                        <div className="gap-2 d-flex">
                         <span 
                            
                              onClick={togglePasswordTextVisibility}
                            >
                              {showpassword ? (
                                <i className="fa-solid fa-eye"></i>
                              ) : (
                                <i className="fa-regular fa-eye-slash"></i>
                              )}
                              
                            </span>
                            <span  onClick={copyToClipboardpassword}>
                              <i class="fa-regular fa-copy"></i>
                              </span>
                              </div>
                            </div>
                   </div>
                   <div className="my-1">
                   <label
                            className="me-2 fw-semibold fs-12"
                        >
                            Type
                            <span className="mandatory">*</span>
                        </label>
                        <SBAComboBox data={type} value={dType} textField="TypeName" valueField="TypeId"   popupSettings={{ className: "modalDD" }} onChange={(e)=>{if(e.value){
                            setDType(e.value)
                        }}} />
                   </div>
                    </div>
                    <div className="col-md-3 mt-1">
                        <div className="d-flex align-items-center mb-3 justify-content-between">
                            <label
                                htmlFor="portfolio"
                                className="me-2 fw-semibold fs-12"
                            >
                                Portfolios
                            </label>
                            <button
                                type="submit"
                                className="p-sm-btn"
                                onClick={()=>{addPortfolio()}}
                            >
                                Add
                            </button>
                        </div>
                        <SBAComboBox
                            className="w-100"
                            textField="Name"
                            valueField="PortfolioId"
                            data={portfolio}
                            value={selectedPortfolio}
                            popupSettings={{ className: "modalDD" }}
                            onChange={(e) => { if (e.value) (setSelectedPortfolio(e.value)) }}
                        />
                        <div className="ag-theme-alpine" style={{ height: "20vh", width: "100%" }}>
                            <AgGridReact rowData={rowPortfolio} columnDefs={portfolioColumnDefs} defaultColDef={{ flex: 1,resizable:true }} ></AgGridReact>
                        </div>
                    </div>
                    <div className="col-md-3 mt-1">
                        <div className="d-flex align-items-center mb-3 justify-content-between">
                            <label
                                htmlFor="asset"
                                className="me-2 fw-semibold fs-12"
                            >
                                Asset
                            </label>
                            <button
                                type="submit"
                                className="p-sm-btn"
                                onClick={()=>{addAsset()}}
                                 >
                                Add
                            </button>
                        </div>
                        <SBAComboBox
                            className="w-100"
                            textField="AssetName"
                            valueField="AssetId"
                            data={Asset}
                            value={selectedAsset}
                            popupSettings={{ className: "modalDD" }}
                            onChange={(e) => { if (e.value) (setSelectedAsset(e.value)) }}
                        />
                        <div className="ag-theme-alpine" style={{ height: "20vh", width: "100%" }}>
                            <AgGridReact rowData={rowAsset} columnDefs={AssetColumnDefs} defaultColDef={{ flex: 1,resizable:true }}></AgGridReact>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="d-flex align-items-center mb-3 justify-content-between">
                            <label
                                htmlFor="document-type"
                                className="me-2 fw-semibold fs-12"
                            >
                                Document Type
                            </label>
                            <button
                                type="submit"
                                className="p-sm-btn"
                                onClick={()=>{addType()}}
                               >
                                Add
                            </button>
                        </div>
                        <SBAComboBox
                            className="w-100"
                            textField="ActivitySubType"
                            valueField="ActivitySubTypeId"
                            data={activityType}
                            value={selectedType}
                            popupSettings={{ className: "modalDD" }}
                            onChange={(e) => { if (e.value) (setSelectedType(e.value)) }}
                        />
                        <div className="ag-theme-alpine" style={{ height: "20vh", width: "100%" }}>
                            <AgGridReact rowData={rowType} columnDefs={DocumentColumnDefs} defaultColDef={{ flex: 1,resizable:true }}></AgGridReact>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="col-md-6 d-flex gap-2">
                        <div>
                        <label
                            className="mb-1 ms-2 fw-semibold fs-12"
                        >
                            Secret Question
                        </label>
                        <div>
                            <input
                                className=" input-default form-control"
                                type="text"
                                value={question}
                                onChange={(e)=>{setQuestion(e.target.value)}}
                            />
                        </div>

                        </div>
                        <div>
                        <label
                            className="mb-1 ms-2 fw-semibold fs-12"
                        >
                            Secret Answer
                        </label>
                        <div>
                            <input
                                className=" input-default form-control"
                                type="text"
                                value={answer}
                                onChange={(e)=>{setAnswer(e.target.value)}}
                            />
                        </div>
                            
                        </div>
                        
                        
                    </div>
                    
                    <div className="row-items">
                    <button
                            type="submit" className="p-sm-btn mx-1" onClick={addSecretQuestions}
                        >
                            Add
                        </button>
                    </div>
                        
                </div>
                <div>
                    <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                        <AgGridReact columnDefs={secretcolDef} defaultColDef={{flex:1,resizable:true}} rowData={rowSecretQuestAns} ></AgGridReact>
                    </div>
                </div>
                <div className="row">
                    
                    <div className="col-md-4">
                        <label
                            htmlFor="secret-question"
                            className="mb-1 ms-2 fw-semibold fs-12"
                        >
                            Notes
                        </label>
                        <div>
                            <textarea
                                className="w-100 input-default form-control"
                                id="Notes"
                                rows="4"
                                value={notes}
                                style={{ resize: "vertical" }} 
                                onChange={(e)=>{setNotes(e.target.value)}}
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-4 ms-auto">
                        <div className="d-flex justify-content-end gap-2">
                        {clientWebsiteloginId > 0 ? clientwebsiteEditAccess?
    <button className="p-sm-btn mx-1" onClick={insertorupdateclientwebsite}>
        Save
    </button>
    :null
 :  <button className="p-sm-btn mx-1" onClick={insertorupdateclientwebsite}>
 Save
</button>}

                            <button className="s-sm-btn mx-1" onClick={() => {
            setshowDrawer(false);
          }}>Cancel</button>
                        </div>
                    </div>
                </div>
            </SBADrawer>  <Modal show={showpasswordModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setshowpasswordModal(false);
          }}
        >
          <Modal.Title>
           Password Info
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <div className="row">
                <div className="col-md-12">
                <label>Password</label>
                <div className="gap-1 d-flex">
                <input
                                className=" input-default form-control"
                                type={
                                    showpasswordtxt ? "text" : "password"
                                  }
                               value={passwordText}
                            />
                            <div className="gap-2 d-flex">
                             <span 
                            
                            onClick={togglePasswordTxtVisibility}
                          >
                            {showpasswordtxt ? (
                              <i className="fa-solid fa-eye"></i>
                            ) : (
                              <i className="fa-regular fa-eye-slash"></i>
                            )}
                          </span>
                          <span onClick={copyToClipboardpasswordtxt}>
                            <i class="fa-regular fa-copy" ></i>
                            </span>
                          </div>
                          </div>
                          </div>
            </div>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setshowpasswordModal(false);
            }}
          >
           Close
          </button>
         
        </Modal.Footer>
      </Modal>
   {/* Delete Modal ----- */}
   <Modal show={showdeleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowDeleteModal(false);
          }}
        >
          <Modal.Title>
          Do you want to delete the Website?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The Website will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowDeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={() => {
              deleteClientWebsite();
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>

            <ToastContainer></ToastContainer>
        </>
    )
}
